import { IIconProps } from './add';

export const IcoArrowUpFilled: React.FC<IIconProps> = ({ style, cy }) => (
  <svg
    width="11"
    height="17"
    viewBox="0 0 11 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
    data-cy={`IcoArrowUpFilled${cy}`}
  >
    <path
      d="M5.5 0L0 4.845L4.125 4.845L4.125 17H6.875L6.875 4.845L11 4.845L5.5 0ZM5.5 0L0 4.845L4.125 4.845L4.125 17H6.875L6.875 4.845L11 4.845L5.5 0Z"
      fill="currentColor"
    />
  </svg>
);
